import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { Breadcrumbs, Reveal, PrimaryButton } from "../components/common";
import { INSIGHTS } from "../data/site";

export function Insights() {
  return (
    <>
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Insights" }]} />
      <section className="container-page py-12 lg:py-16">
        <span className="eyebrow">Insights</span>
        <h1 className="mt-4 max-w-3xl font-heading text-[34px] font-800 leading-[1.1] text-brand-ink md:text-[52px]">Perspectives on documentation quality and the human layer.</h1>
      </section>
      <section className="pb-24">
        <div className="container-page grid gap-6 md:grid-cols-3">
          {INSIGHTS.map((a, i) => (
            <Reveal key={a.slug} delay={i}>
              <Link to={`/insights/${a.slug}`} className="group flex h-full flex-col rounded-2xl border border-brand-border bg-white p-7 transition-transform hover:-translate-y-1" data-testid={`article-${a.slug}`}>
                <span className="w-fit rounded-full bg-brand-alt px-3 py-1 text-[12px] font-600 text-brand-slate">{a.cat}</span>
                <h2 className="mt-4 font-heading text-[20px] font-700 leading-snug text-brand-ink">{a.title}</h2>
                <p className="mt-2.5 flex-1 text-[15px] leading-relaxed text-brand-muted">{a.excerpt}</p>
                <div className="mt-5 flex items-center justify-between">
                  <span className="flex items-center gap-1.5 text-[13px] text-brand-muted"><Clock className="h-3.5 w-3.5" /> {a.read}</span>
                  <ArrowRight className="h-4 w-4 text-brand-primary transition-transform group-hover:translate-x-1" />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}

export function Article() {
  const { slug } = useParams();
  const a = INSIGHTS.find((x) => x.slug === slug);
  if (!a) return <Navigate to="/insights" replace />;
  return (
    <>
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Insights", to: "/insights" }, { label: a.title }]} />
      <article className="container-page py-12 lg:py-16">
        <span className="eyebrow">{a.cat}</span>
        <h1 className="mt-4 max-w-3xl font-heading text-[32px] font-800 leading-[1.12] text-brand-ink md:text-[46px]">{a.title}</h1>
        <p className="mt-4 flex items-center gap-1.5 text-[13px] text-brand-muted"><Clock className="h-3.5 w-3.5" /> {a.read} read</p>
        <div className="mt-8 max-w-2xl">
          <p className="font-serif text-[21px] italic leading-relaxed text-brand-ink">{a.excerpt}</p>
          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-brand-muted">
            <p>This is placeholder editorial content for the Primevanta Global insights section. Articles are editable and can be connected to a CMS later.</p>
            <p>Documentation moves through capture, refinement and delivery. At each stage, experienced human judgement resolves terminology, context and formatting that automated tools alone cannot reliably handle.</p>
            <p>The result is documentation you can use with clarity and confidence—reviewed, structured and accountable.</p>
          </div>
        </div>
        <div className="mt-10"><PrimaryButton to="/contact" testid="article-cta">Discuss a Project</PrimaryButton></div>
      </article>
    </>
  );
}
